import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Input, Tabs, Typography } from "antd";
import Button from "../../components/Button";
import { useAuth } from "../../contexts/AuthContext";
import { AuthContainer } from "../../styles/LoginSignUp/authContainer";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import {
  validationEmail,
  validationFullName,
  validationCnpj,
  validationCpf,
  validationPassword,
} from "../../utils/formValidations";

interface IData {
  email: string;
  pass: string;
  passConfirmation: string;
  username: string;
  usernameEscritorio: string;
  name: string;
}

interface IProps {
  className?: string;
}

const Cadastro: React.FC<IProps> = ({ className }) => {
  const navigate = useNavigate();
  const [form] = Form.useForm<IData>();
  const { handleSignUp, loading } = useAuth();

  const [isPj, setIsPj] = useState(true);
  const [visiblePass, setVisiblePass] = useState(false);

  const onFinish = (data: IData) => {
    handleSignUp({
      ...data,
      policiesAccepted: true,
      username: String(data.username).replace(/[_.-/-]/g, ""),
      usernameEscritorio: String(data.usernameEscritorio).replace(
        /[_.-/-]/g,
        ""
      ),
      isAssessor: !isPj,
    });
  };


  useEffect(() => {
    // Redireciona automaticamente para a tela de login
    navigate("/p/login", { replace: true });
  }, [navigate]);

  const RegisterForm = (
    <Form form={form} size="large" onFinish={onFinish}>
      <Form.Item name="name" rules={validationFullName}>
        <Input placeholder={isPj ? "Razão social" : "Nome completo"} />
      </Form.Item>

      <Form.Item name="username" rules={isPj ? validationCnpj : validationCpf}>
        <Input maxLength={20} placeholder={isPj ? "CNPJ" : "CPF"} />
      </Form.Item>

      {!isPj && (
        <div className="cnpj-assessor-cadastro">
          <Form.Item name="usernameEscritorio" rules={validationCnpj}>
            <Input placeholder="CNPJ do seu escritório" />
          </Form.Item>
          <Typography.Text
            onClick={() =>
              form.setFieldValue("usernameEscritorio", "02.332.886/0001-04")
            }
          >
            {/* Sou XP Matriz */}
          </Typography.Text>
        </div>
      )}

      <Form.Item name="email" rules={validationEmail}>
        <Input placeholder="E-mail" />
      </Form.Item>

      <div className="password-with-eye">
        <Form.Item name="pass" rules={validationPassword}>
          {visiblePass ? (
            <Input placeholder="Senha" />
          ) : (
            <Input.Password placeholder="Senha" visibilityToggle={false} />
          )}
        </Form.Item>
        <Button
          size="large"
          type="text"
          onClick={() => setVisiblePass((visible) => !visible)}
          icon={visiblePass ? <EyeInvisibleOutlined /> : <EyeOutlined />}
        />
      </div>

      <div className="buttons">
        <Button
          block
          size="large"
          type="primary"
          htmlType="submit"
          loading={loading}
        >
          Começar
        </Button>
      </div>
    </Form>
  );

  return (
    <AuthContainer className="beauty-scrollbar">
      <div className="auth-content">
        <div className="form-container register">
          <h1 className="app-title">Cadastre sua conta</h1>

          <Tabs
            onChange={(activeKey) => {
              setIsPj(activeKey === "escritorio");
            }}
          >
            <Tabs.TabPane key="escritorio" tab="SOU ESCRITÓRIO">
              {RegisterForm}
            </Tabs.TabPane>
            <Tabs.TabPane key="assessor" tab="SOU ASSESSOR">
              {RegisterForm}
            </Tabs.TabPane>
          </Tabs>

          <Typography.Paragraph className="termos">
            Ao clicar em "Começar" você afirma que leu, entendeu e está de
            acordo com os{" "}
            <a
              href="https://velotax-assets.s3.us-east-1.amazonaws.com/reports/Velotax+-+Termos+de+Uso+27Ago25.pdf"
              target="_blank"
              rel="noreferrer"
            >
              Termos de Uso
            </a>
            ,{" "}
            <a
              href="https://velotax-assets.s3.us-east-1.amazonaws.com/reports/Velotax+-+Pol%C3%ADtica+de+Privacidade+27Ago25.pdf"
              target="_blank"
              rel="noreferrer"
            >
              Política de Privacidade
            </a>{" "}
            e{" "}
            <a
              href="https://velotax-assets.s3.us-east-1.amazonaws.com/reports/Velotax+-+Termos+e+Condi%C3%A7%C3%B5es+de+Contrata%C3%A7%C3%A3o+27Ago25.pdf"
              target="_blank"
              rel="noreferrer"
            >
              Termos e Condições de Contratação
            </a>{" "}
            do VeloPrime.
          </Typography.Paragraph>

          <div className="footer">
            Já possui uma conta?
            <Button
              type="text"
              disabled={loading}
              className="btn-underlined"
              onClick={() => navigate("/p/login")}
            >
              Acessar
            </Button>
          </div>
        </div>
      </div>
    </AuthContainer>
  );
};

export default Cadastro;
